import React from 'react';

interface UpgradeRequiredProps {
  featureName: string;
  requiredPlan?: 'Pro' | 'Business';
  onUpgrade: () => void;
}

export const UpgradeRequired: React.FC<UpgradeRequiredProps> = ({
  featureName,
  requiredPlan = 'Pro',
  onUpgrade,
}) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '60px 24px',
      textAlign: 'center',
      maxWidth: 480,
      margin: '0 auto',
    }}>
      {/* Ícone */}
      <div style={{
        width: 64, height: 64, borderRadius: 16,
        background: 'rgba(56,139,253,.1)',
        border: '1px solid rgba(56,139,253,.25)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: 20,
      }}>
        <svg width="28" height="28" fill="none" stroke="#388bfd" strokeWidth="1.5" viewBox="0 0 24 24">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
      </div>

      {/* Título */}
      <h3 style={{ fontSize: 17, fontWeight: 700, color: 'var(--text)', marginBottom: 10 }}>
        {featureName}
      </h3>

      {/* Descrição */}
      <p style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.7, marginBottom: 8 }}>
        Esta funcionalidade está disponível a partir do plano{' '}
        <strong style={{ color: 'var(--blue)' }}>{requiredPlan}</strong>.
        Faça upgrade para desbloquear e aproveitar todos os recursos financeiros do ServiceFlow.
      </p>

      {/* Benefícios do plano */}
      <div style={{
        background: 'var(--bg2)',
        border: '1px solid var(--border)',
        borderRadius: 10,
        padding: '14px 20px',
        marginBottom: 24,
        width: '100%',
        textAlign: 'left',
      }}>
        <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--muted2)', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 10 }}>
          Incluso no plano {requiredPlan}
        </div>
        {requiredPlan === 'Pro' ? (
          <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 6 }}>
            {[
              'Painel de Faturamento completo',
              'Gastos com materiais e ferramentas',
              'Histórico de orçamentos na calculadora',
              'Produtividade financeira por técnico',
              'Ranking de performance',
              'Agenda de montagem completa com filtros',
            ].map(item => (
              <li key={item} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: 'var(--muted)' }}>
                <svg width="12" height="12" fill="none" stroke="var(--green)" strokeWidth="2.5" viewBox="0 0 24 24">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
                {item}
              </li>
            ))}
          </ul>
        ) : (
          <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 6 }}>
            {[
              'Tudo do plano Pro',
              'Técnicos e admins ilimitados',
              'Relatórios entre períodos',
              'Audit log completo',
              'Suporte prioritário',
            ].map(item => (
              <li key={item} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: 'var(--muted)' }}>
                <svg width="12" height="12" fill="none" stroke="var(--green)" strokeWidth="2.5" viewBox="0 0 24 24">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
                {item}
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Preços */}
      <div style={{ display: 'flex', gap: 10, width: '100%', marginBottom: 20 }}>
        <div style={{
          flex: 1, background: 'var(--blue-dim)',
          border: '1px solid var(--blue-border)',
          borderRadius: 8, padding: '10px 14px',
        }}>
          <div style={{ fontSize: 11, color: 'var(--blue)', fontWeight: 600, marginBottom: 3 }}>Pro</div>
          <div style={{ fontFamily: 'DM Mono,monospace', fontSize: 16, fontWeight: 700, color: 'var(--blue)' }}>R$ 299/mês</div>
          <div style={{ fontSize: 10, color: 'var(--muted)', marginTop: 2 }}>ou R$ 2.990/ano</div>
        </div>
        <div style={{
          flex: 1,
          background: 'rgba(163,113,247,.1)',
          border: '1px solid rgba(163,113,247,.3)',
          borderRadius: 8, padding: '10px 14px',
        }}>
          <div style={{ fontSize: 11, color: 'var(--purple)', fontWeight: 600, marginBottom: 3 }}>Business</div>
          <div style={{ fontFamily: 'DM Mono,monospace', fontSize: 16, fontWeight: 700, color: 'var(--purple)' }}>R$ 399/mês</div>
          <div style={{ fontSize: 10, color: 'var(--muted)', marginTop: 2 }}>ou R$ 3.990/ano</div>
        </div>
      </div>

      {/* Botão */}
      <button
        onClick={onUpgrade}
        style={{
          width: '100%',
          padding: '12px',
          borderRadius: 8,
          fontSize: 14,
          fontWeight: 600,
          cursor: 'pointer',
          border: 'none',
          background: 'var(--blue)',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
        }}
      >
        <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
          <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
          <polyline points="17 6 23 6 23 12"/>
        </svg>
        Ver planos e fazer upgrade
      </button>
    </div>
  );
};
